export const StaticIndexConfig = [{
    value: "pipei",
    label: "资源匹配 精准对接",
    children: [{
        value: "kanzhengce",
        label: "看政策"
      },
      {
        value: "chaxiangmu",
        label: "查项目"
      },
      {
        value: "zhaozijin",
        label: "找资金"
      },
      {
        value: "huodanbao",
        label: "获担保"
      },
      {
        value: "pindanbao",
        label: "聘专家"
      },
      {
        value: "chuangbiaozhun",
        label: "创标准"
      }
    ]
  },
  {
    value: "xinjijian",
    label: "新基建",
    children: [{
        value: "zhinengyingyong",
        label: "智慧应用"
      },
      {
        value: "shujuzhineng",
        label: "数据智能"
      },
      {
        value: "shengtaixitong",
        label: "生态系统"
      },
      {
        value: "kexinanquan",
        label: "可信安全"
      },
      {
        value: "xinxingwangluo",
        label: "新型网络"
      }
    ]
  },
  {
    value: "zhihuizhuanqu",
    label: "智慧专区",
    children: [{
        value: "zhihuizhujian",
        label: "智慧住建"
      },
      {
        value: "zhihuishequ",
        label: "智慧社区"
      },
      {
        value: "zhihuichuxing",
        label: "智慧出行"
      },
      {
        value: "zhihuijiankang",
        label: "智慧健康"
      }
    ]
  },
  {
    value: "shuzishangyun",
    label: "数字上云",
    children: [{
        value: "yunjisuan",
        label: "云计算"
      },
      {
        value: "cunchuyuCDN",
        label: "存储与CDN"
      },
      {
        value: "zhihuichuxing",
        label: "内容安全"
      },
      {
        value: "yuming",
        label: "域名"
      }
    ]
  },
  {
    value: "yunshangzhibo",
    label: "云上直播",
    children: [{
        value: "zhibohudong",
        label: "直播互动"
      },
      {
        value: "zhihuichangjing",
        label: "智慧场景"
      }
    ]
  },
  {
    value: "kechuangpingtai",
    label: "科创平台",
    children: [{
        value: "yidaiyilu",
        label: "一带一路"
      },
      {
        value: "difangchanye",
        label: "地方产业"
      }
    ]
  }
]
